import { Link, LinkProps } from "@mui/material";

interface IProps extends LinkProps{
  carID?: number|null;
}

export default function CarLink(props:IProps){
  const {
    carID,
    onClick,
    ...otherProps
  } = props
  
  return (
    <Link
      {...otherProps}
      href={`#car-${carID}`}
      onClick={(e)=>{
        if(!!onClick) onClick(e);
        e.stopPropagation();
      }}
    />
  )
}